import colors from '../globals/colors';
const modal = {
    'with-info': {
        header: {
            desktop: {
                padding: '48px 48px 32px',
                color: colors.grey84,
                textAlign: 'center',
                title: {
                    fontSize: '24px',
                    lineHeight: '32px',
                },
                subtitle: {
                    fontSize: '18px',
                    lineHeight: '24px',
                },
            },
            mobile: {
                padding: '64px 24px 32px',
                color: colors.grey84,
                textAlign: 'center',
                title: {
                    fontSize: '24px',
                    lineHeight: '32px',
                },
                subtitle: {
                    fontSize: '16px',
                    lineHeight: '20px',
                },
            },
        },
    },
    'with-form': {
        header: {
            desktop: {
                padding: '48px 48px 32px',
                color: colors.grey84,
                textAlign: 'left',
                title: {
                    fontSize: '24px',
                    lineHeight: '32px',
                },
                subtitle: {
                    fontSize: '18px',
                    lineHeight: '24px',
                },
            },
            mobile: {
                padding: '16px 0 16px 16px',
                color: colors.secondary.normal,
                textAlign: 'left',
                title: {
                    fontSize: '18px',
                    lineHeight: '24px',
                },
                subtitle: {
                    fontSize: '16px',
                    lineHeight: '20px',
                },
            },
        },
    },
};
export default modal;
